export function buildAuthorizationHeaders(
  getAccessToken: () => string | undefined
): { HeaderName: string; HeaderValue: string }[] {
  const token = getAccessToken();
  if (!token) {
    return [];
  }
  return [{ HeaderName: 'Authorization', HeaderValue: `Bearer ${token}` }];
}
